import client from './client';
import { EnCryptData, DeCryptData } from '../util/CustomUtil';


//1:1 문의 추가하기
export const addConsult = ({ formData }) => {

    // for (var key of formData.keys()) {
    //     console.log(key);
    // }
    // for (var value of formData.values()) {
    // console.log(value);
    // }

    return client.post('/cs/addconsult', formData);
}

//1:1 문의 리스트 가져오기
export const getConsult = ({ user_email, curPage }) => {
    //console.log("getConsult = " + user_email + curPage)
    let params = new URLSearchParams();
    let paramdata = { user_email, curPage }
    params.append('data', EnCryptData(JSON.stringify(paramdata)));


    return client.post('/cs/consult', params);
}

//공지 알리미 리스트 가져오기
export const getNotice = ({ ntc_type, curPage }) => {
    //console.log("getNotice = " + ntc_type + curPage)
    let params = new URLSearchParams();
    params.append('ntc_type', ntc_type);
    params.append('curPage', curPage);

    return client.post('/cs/notice', params);
}

//자주 찾는 질문 리스트 가져오기
export const getFaq = ({ faq_type, curPage }) => {
    //console.log("getFaq = " + faq_type + curPage)
    let params = new URLSearchParams();
    params.append('faq_type', faq_type);
    params.append('curPage', curPage);

    return client.post('/cs/faq', params);
}

//홈 화면에서 팝업 데이터 가져오기
export const getPopUp = (param) => {

    return client.get('/cs/popup' + param);
}